import _ from 'lodash';
import React from 'react';
import { ActionMenuBadge, IActionMenuBadgeItem } from './action-menu-badge';
import { assembleName, generateLabel } from './util';

export interface ISellerBadgeProps {
    className?: string;
    id?: string;
    first?: string;
    last?: string;
    suffix?: string;
    type?: string;
    tooltip?: string;
    items?: IActionMenuBadgeItem[];
}
export const SellerBadge: React.FunctionComponent<ISellerBadgeProps> = (
    props: ISellerBadgeProps,
): React.ReactElement => {
    const { className, id, first, last, suffix, type, tooltip, items } = props;
    const name = assembleName(first, last, suffix);

    return (
        <ActionMenuBadge
            className={className}
            label={`${type ? _.capitalize(type) + ' ' : ''} ${generateLabel('Seller', id, name)}`}
            tooltip={tooltip}
            items={items}
            id={id}
            Symbol={<div>💼</div>}
        />
    );
};
